import clsx from 'clsx';
import { Suspense } from 'react';
import { Await } from 'react-router-dom';

export type MenuItemCountProps = {
  count?: number | Promise<number>;
  selected?: boolean;
  'aria-label'?:
    | React.ComponentPropsWithoutRef<'div'>['aria-label']
    | ((count: number) => string);
};

export const MenuItemCount = ({
  count,
  selected,
  'aria-label': ariaLabel,
}: MenuItemCountProps) => {
  if (count !== undefined) {
    return (
      <Suspense
        fallback={
          <div className="size-5 animate-pulse rounded-full bg-teal-350" />
        }
      >
        <Await resolve={count}>
          {(count?: number) => {
            if (count !== undefined) {
              return (
                <div
                  className={clsx(
                    'flex h-5 min-w-5 items-center justify-center rounded-full bg-gray-200 px-1.5 text-xs font-semibold text-sage-700 shadow-sm',
                    selected && 'bg-teal-50 text-sage-800',
                  )}
                  aria-label={
                    typeof ariaLabel === 'function'
                      ? ariaLabel(count)
                      : ariaLabel
                  }
                >
                  {count > 100 ? '99+' : count}
                </div>
              );
            }

            return null;
          }}
        </Await>
      </Suspense>
    );
  }

  return null;
};
